<template>
  <!--空调服务协议界面内容 -->
  <div style="width:100%;height:calc(100vh - 50px);overflow: hidden;" ref="airconditionfragment">
    <div>
      <hint></hint>
      <question-list :Datalist="datalist" @scrollto="ScrollTo" :scroll="scroll"></question-list>
      <div class="struction_style" id='airstruction' v-html="struction">
        <!--:style="{height:screenHeight+'px'}"-->
      </div>
      <aircondition-charge class="struction_style" />
    </div>
  </div>
</template>
<script>
import hint from './hint.vue'
import QuestionList from './questionList.vue'
import { airstruction } from '../struction/airStruction'
import AirconditionCharge from './AirconditionCharge.vue';
import BScroll from '@better-scroll/core'
var self;
export default {
  name: "Aircondition",
  data() {
    return {
      screenHeight: 500,
      datalist: [
        { des: '·空调安装说明', ref: 'airinstruction', href: '#airinstruction' },
        { des: '·空调"三包期限"？', ref: 'airdeadline', href: '#airdeadline' },
        { des: '·不属于"三包"范围的说明', ref: 'airrange', href: '#airrange' },
        { des: '·空调服务收费标准', ref: 'airstandard', href: '#airstandard' },
        { des: '·空调安装收费标准', ref: 'airinstall', href: '#airinstall' }
      ],
      struction: airstruction.airTitle + airstruction.airContent,
      scroll:'',
    }
  },
  props: {
    active: {
      type: String,
      default:'',
    }
  },
  mounted() {
    this.screenHeight = window.innerHeight - 320;
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.airconditionfragment, {
        click: true,
        scrollY: true,
        bounce: true,
      });
    });
  },
  methods: {
    ScrollTo: function (ref) {
      var updistance = document.getElementById("airstruction").offsetTop;
      var distance = document.getElementById(ref).offsetTop;
      var scrolldis = document.getElementById('airstruction').scrollTop = distance - updistance - 10;
    }
  },
  components: {
    'hint': hint,
    'question-list': QuestionList,
    'aircondition-charge': AirconditionCharge
  },
  watch: {
    active(newValue,oldValue){
      if(newValue === "air_container"){
        this.scroll.refresh();
      } 
    }
  }
}
</script>

<style>
.struction_style {
  width: 92%;
  display: inline-block;
  text-align: left;
  /* padding-left: 4%; */
  line-height: 120%;
  overflow-y: scroll;
  background: #FAFAFA;
}
.struction_style p{
  line-height: 25px;
  color: #999;
  font-size: 14px;
  margin:0;
}
.struction_style  p.title{
  font-size: 18px;
  color: #333;
  margin: 15px 0;
}
.inner {
  height: calc(100% + 1px);
}
</style>



// WEBPACK FOOTER //
// src/components/Aircondition.vue